import { render, staticRenderFns } from "./LegalWarning.vue?vue&type=template&id=6a75cb60&scoped=true&"
import script from "./LegalWarning.vue?vue&type=script&lang=js&"
export * from "./LegalWarning.vue?vue&type=script&lang=js&"
import style0 from "./LegalWarning.vue?vue&type=style&index=0&id=6a75cb60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a75cb60",
  null
  
)

export default component.exports